import { inject, Injectable } from '@angular/core';
import { notify, SiaHttpService } from '@sia/shared';
import { MicrosoftAuthApi } from '../apis/microsoft-auth-api';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftAuthService {

  #http = inject(SiaHttpService);

  #microsoftAuthApi = inject(MicrosoftAuthApi);


  logout(scope: string, email: string | undefined) {
    return this.#microsoftAuthApi.logout(scope, email);
  }


  async loginPopup(
    scopeType: string,
    clientId: string,
    redirectUri: string
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const result = await this.loginForWorkflow(scopeType, clientId, redirectUri);
        resolve(result);
      } catch (error) {
        reject(error);
      }
    });
  }

  async loginForWorkflow(
    scopeType: string,
    clientId: string,
    redirectUri: string
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!clientId) {
        notify('Client ID mancante per Microsoft Auth', 2000, 'error');
        reject(new Error('Client ID mancante'));
        return;
      }

      // Manual OAuth2 Code Flow
      const tenant = 'common'; // Or specific tenant
      const scopes = 'offline_access User.Read Mail.Read Mail.ReadWrite'; // Scopes needed for backend
      const url = `https://login.microsoftonline.com/${tenant}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&response_mode=query&scope=${encodeURIComponent(scopes)}&state=${scopeType}&prompt=select_account`;

      const width = 600;
      const height = 600;
      const left = window.screen.width / 2 - width / 2;
      const top = window.screen.height / 2 - height / 2;

      const popup = window.open(
        url,
        'Microsoft Auth',
        `width=${width},height=${height},top=${top},left=${left}`,
      );

      if (!popup) {
        notify('Popup bloccato. Abilita i popup per accedere.', 2000, 'error');
        reject(new Error('Popup bloccato'));
        return;
      }

      const interval = setInterval(async () => {
        try {
          let isClosed = false;
          try {
            isClosed = popup.closed;
          } catch (e) {
            // Can happen if COOP blocks access. preventing crash.
          }

          if (isClosed) {
            clearInterval(interval);
            reject(new Error('Popup chiuso dall\'utente'));
            return;
          }

          let href = '';
          try {
            href = popup.location.href;
          } catch (e) {
            // Expected while cross-origin
          }

          if (href && href.includes(redirectUri)) {
            const urlParams = new URLSearchParams(new URL(href).search);
            const code = urlParams.get('code');
            const error = urlParams.get('error');

            popup.close();
            clearInterval(interval);

            if (code) {
              try {
                const result = await this.activateToken(code, scopeType);
                resolve(result);
              } catch (err) {
                reject(err);
              }
            } else if (error) {
              notify(`Errore login Microsoft: ${error}`, 3000, 'error');
              reject(new Error(error));
            }
          }
        } catch (e) {
          // Ignore other errors
        }
      }, 500);
    });
  }

  async activateToken(
    code: string,
    scopeType: string,
    controller: string = 'microsoft-token'
  ): Promise<any> {
    try {
      const data = {
        accessCode: code,
        scopeId: 'https://graph.microsoft.com/.default', // Placeholder, not strictly used by backend for Outlook logic but required by DTO
        scopeType: scopeType,
      };

      // Call token-workflow/activate
      // Note: Backend parses "Outlook" from ScopeType to switch logic
      const response: any = await this.#http.post(
        controller + '/activate',
        data,
      );

      if (response && response.email) {
        notify('Account Microsoft collegato con successo', 3000, 'success');
        return response;
      } else {

      }
    } catch (err: any) {
      notify("Errore durante l'attivazione del token Microsoft", 3000, 'error');
      console.error(err);
      throw err;
    }
  }
}
